/**
 * Gold-section newsletter form from the Webflow detail_product export.
 *
 * This is the gold "Put your hands first…" CTA block (distinct from the shared
 * black Newsletter section), so it is reproduced here rather than reused. The
 * form validates and shows the original Webflow success state client-side; there
 * is no backend, matching the conversion scope.
 */
import type { ChangeEvent, FC, FormEvent } from 'react'

import { useState } from 'react'

export const NewsletterCta: FC = () => {
    const [email, setEmail] = useState('')
    const [submitted, setSubmitted] = useState(false)

    const onSubmit = (event: FormEvent) => {
        event.preventDefault()
        if (!email.trim()) return
        setSubmitted(true)
    }

    if (submitted) {
        return (
            <div className='success-message gold w-form-done' style={{ display: 'block' }}>
                <div>Thank you! Your submission has been received!</div>
            </div>
        )
    }

    return (
        <form name='wf-form-Newsletter-Email' method='get' className='newsletter-form' onSubmit={onSubmit}>
            <div className='fade-in-move-on-scroll _100width'>
                <label htmlFor='Newsletter-Email-2' className='newsletter-field-label'>Subscribe to our newsletter.</label>
            </div>
            <div className='fade-in-move-on-scroll _100width'>
                <input
                    className='newsletter-text-field white w-input'
                    maxLength={256}
                    name='Newsletter-Email-2'
                    placeholder='E-mail'
                    type='email'
                    id='Newsletter-Email-2'
                    required
                    value={email}
                    onChange={(event: ChangeEvent<HTMLInputElement>) => setEmail(event.target.value)}
                />
            </div>
            <div className='fade-in-move-on-scroll _100width'>
                <input type='submit' className='button subscribe-button w-button' value='SUBSCRIBE' />
            </div>
        </form>
    )
}
